<p>Template view</p>
<button  (click)="Create()" mat-fab extended class="it-doc-btn-create create-button">
    <img class="clickable-icon" src="../../../../../assets/icon/add.svg" />
    <span class="text">{{ navigatorService.Dictionary?.Upload }}</span>
  </button>